import { CircularProgress } from "@mui/material";
import { styled } from "@mui/material/styles";

import Modal from "../Modal";

export const Wrapper = styled("div")(() => ({
  marginTop: 0,
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: 8,
  padding: "16px",
}));

export const StylishModal = styled(Modal)(() => ({
  width: 910,
  "@media screen and (max-width: 1024px)": {
    width: "100%",
  },
  "@media screen and (max-width: 435px)": {
    width: 360,
  },
}));

interface CardProps {
  disabled?: boolean;
  active?: boolean;
}

const getColor = (isDisabled?: boolean, isActive?: boolean) => {
  if (isActive) return "#0055A4";
  if (isDisabled) return "#D0D5DD";
  return "#344054";
};

const getTextColor = (isDisabled?: boolean, isActive?: boolean) => {
  if (isActive) return "#0055A4";
  if (isDisabled) return "#D0D5DD";
  return "#344054";
};

const getDescriptionColor = (isDisabled?: boolean, isActive?: boolean) => {
  if (isActive) return "#0055A4";
  if (isDisabled) return "#D0D5DD";
  return "#475467";
};

export const Card = styled("div")((props: CardProps) => ({
  border: props.active ? "1px solid #0055A4" : "1px solid #D0D5DD",
  borderRadius: 8,
  padding: "10px 16px",
  minHeight: 70,
  maxHeight: 80,
  display: "flex",
  alignItems: "flex-start",
  gap: 8,
  cursor: props.disabled ? "not-allowed" : "pointer",
  backgroundColor: "#FFFFFF",
  position: "relative",
  transition: "all 0.2s ease-in-out",
  "&:hover": {
    border: props.disabled ? "1px solid #D0D5DD" : "1px solid #0055A4",
  },
}));

export const IconContainer = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  width: 24,
  height: 24,
}));

export const WrapperCardBody = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  gap: 10,
  flex: 1,
}));

export const CardBody = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: 8,
  flex: 1,
}));

export const CardTitle = styled("span")<{ active?: boolean; disabled?: boolean }>(
  (props) => ({
    color: getTextColor(props.disabled, props.active),
    fontFamily: "Manrope, sans-serif",
    fontSize: 14,
    fontWeight: 700,
    lineHeight: "20px",
    letterSpacing: "0.25px",
  })
);

export const CardText = styled("span")<{ active?: boolean; disabled?: boolean }>(
  (props) => ({
    color: getDescriptionColor(props.disabled, props.active),
    fontFamily: "Manrope, sans-serif",
    fontSize: 14,
    fontWeight: 400,
    lineHeight: "20px",
    letterSpacing: "0.25px",
  })
);

export const CheckmarkContainer = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  width: 20,
  height: 20,
}));

export const LoadingContainer = styled("div")(() => ({
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(255, 255, 255, 0.8)",
  borderRadius: 8,
}));

export const CardLoading = styled(CircularProgress)(() => ({
  color: "#0055A4",
}));

